export enum PoaType {
    Limited = "Limited",
    General = "General"
}

export const fromValue = (poaTypeValue: string) => {
    const matchingEntry = Object.entries(PoaType).find((entry) => {
        return entry[1] === poaTypeValue;
    })
    if(matchingEntry) {
        return matchingEntry[1];
    } else {
        throw new Error("PoaType enum not found for value: " + poaTypeValue);
    }
}